<template>
    <HeaderComponent title="Add User" :actions="[
        {label: 'Save User', click: updateUser, class: 'bg-blue-500 text-white'},
    ]"/>
    <FormKit type="form" submit-label="Add User" @submit="updateUser">
        <FormKit
            type="text"
            name="full_name"
            label="Full Name"
            v-model="user.full_name"
        />
        <FormKit
            type="text"
            name="username"
            label="Username"
            v-model="user.username"
        />
        <FormKit
            type="checkbox"
            name="is_admin"
            label="Is Admin"
            v-model="user.is_admin"
        />
        <div class="formkit-wrapper">
            <label class="block text-slate-700 text-base font-bold dark:text-slate-300 mb-1.5 formkit-label" for="input_1">Affiliates</label>
            <Multiselect
            v-model="user.affiliates"
            :options="affiliates"
            :multiple="true"
            label="name"
            track-by="id"
            class="mb-4"
            />
        </div>
    </FormKit>
</template>

<script setup>
import { usePage, router } from "@inertiajs/vue3";
import { computed } from "vue";
import { FormKit } from "@formkit/vue";
import Multiselect from "vue-multiselect";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();

const user = computed(() => page.props.user);
const affiliates = computed(() => page.props.affiliates);

const updateUser = () => {
    router.post(
        `/admin/users/add`,
        {
            user: user.value,
        },
        {
            headers: {
                "X-CSRF-Token": page.props.csrfToken,
            },
        },
    );
};
</script>
